/**
 * @func Vue钩子，原型链函数，输出定制化后的Vue对象
 */

import Vue from "vue";
import axios from "axios";
Vue.prototype.$axios = function (method, uri, data, vm) {
    return new Promise((resolve, reject) => {
        let config = {
            method: method,
            url: process.env.VUE_APP_BASE_API+uri
        };
        data.params ? (config.params = data.params) : (config.data = data); //区别post和get传参
        axios(config)
            .then(r => {
                if (r.status == 200) {
                    resolve(r);
                }
            })
            .catch(e => {
                let res = JSON.parse(JSON.stringify(e))
                if (res.status == 403) {
                    vm.$confirm('无效的会话，或者会话已过期，请重新登录。', '系统提示', {
                        confirmButtonText: '重新登录',
                        showClose: false,
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {
                        location.href = window.location.origin + "/login";
                    }).catch(() => {});
                }
                reject(e);
            });
    });
};

/**
 * 请求发起拦截器    test
 **/
axios.interceptors.request.use(
    config => {
        config.headers.common = Object.assign({}, config.headers.common, {
            token: localStorage.getItem('token')
        });
        config.timeout = 8000000; // 设置超时时间
        return config;
    },
    err => null
);

/**
 * 请求响应拦截器
 **/
axios.interceptors.response.use(
    res => {
        return res;
    },
    err => {
        return Promise.reject(err);
    }
);
Vue.prototype.axios = axios;

export {
    Vue
};
